import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './MobileNavBarSubCategory.css';
import { ConnectedLogoutButton } from '../LogoutButton';
import * as util from '../../utils/urlParams';

export class MobileNavBarSubCategory extends Component {
  handleClick = (subCategory) => {
    const { category } = this.props;

    // add delay to reveal subcategory highlight on menu close
    this.props.onClick(category, subCategory, undefined, 250);
  };

  handleOverlayClick = (e) => {
    e.preventDefault();
    const { selectedCategory, selectedSubCategory } = this.props;

    this.props.onClick(selectedCategory, selectedSubCategory, undefined);
  };

  appendSearch(categoryName, subCategoryId = '') {
    const {
      electricalGraphDateRange,
      gasGraphDateRange,
      diagnosticsGraphDateRange,
      thermostatGraphDateRange,
      category,
    } = this.props;

    let graphDateRange;
    switch (categoryName) {
      // set the graphDateRange to the corresponding one based on category
      case 'Electrical Usage':
        const electricalDateFromSession = window.sessionStorage.getItem('electricalGraphDateRange');
        graphDateRange = electricalDateFromSession ? JSON.parse(electricalDateFromSession) : electricalGraphDateRange;
        break;
      case 'Gas Usage':
        const gasDateFromSession = window.sessionStorage.getItem('gasGraphDateRange');
        graphDateRange = gasDateFromSession ? JSON.parse(gasDateFromSession) : gasGraphDateRange;
        break;
      case 'Diagnostics':
        const diagnosticsDateFromSession = window.sessionStorage.getItem('diagnosticsGraphDateRange');
        graphDateRange = diagnosticsDateFromSession
          ? JSON.parse(diagnosticsDateFromSession)
          : diagnosticsGraphDateRange;
        break;
      case 'Thermostats':
        const thermostatDateFromSession = window.sessionStorage.getItem('thermostatGraphDateRange');
        graphDateRange = thermostatDateFromSession ? JSON.parse(thermostatDateFromSession) : thermostatGraphDateRange;
        break;
      default:
        graphDateRange = {};
        break;
    }

    let search = '';
    if (categoryName !== 'Help' && categoryName !== 'Account' && categoryName !== 'Alerts') {
      if (category.id === 'diagnostics') {
        let customDataPoints = JSON.parse(window.sessionStorage.getItem('customDataPoints')) || {};

        let customDataPointForSubCategory = customDataPoints[subCategoryId];

        search = util.addSearchParams(graphDateRange, customDataPointForSubCategory);
      } else {
        search = util.addSearchParams(graphDateRange);
      }

      if (search) {
        return `?${search}`;
      }
    }

    return search;
  }

  renderSubCategoryLink(subCategory) {
    const { category } = this.props;
    const isSelected = subCategory.url === this.props.selectedSubCategory.url;

    const targetUrlWithSearch = subCategory.url + this.appendSearch(category.name, subCategory.id);
    return (
      <Link
        onClick={() => this.handleClick(subCategory)}
        className={`nav-bar-subcategory__link ${isSelected ? 'nav-bar-subcategory__link--selected' : ''}`}
        to={targetUrlWithSearch}
        id={`${category.id}-${subCategory.name.toLowerCase()}`}
      >
        <div className={`nav-bar-subcategory__bar ${isSelected ? 'nav-bar-subcategory__bar--selected' : ''}`}>
          {subCategory.name}
        </div>
      </Link>
    );
  }

  render() {
    const { subCategories = [] } = this.props;

    if (subCategories.length === 0) {
      return null;
    }

    return (
      <ul className="nav-bar-subcategory">
        {subCategories.map((subCategory, index) => (
          <li className="nav-bar-subcategory__item" key={subCategory.id || index}>
            {subCategory.name === 'Log Out' ? (
              <div className="nav-bar-subcategory__link">
                <ConnectedLogoutButton mobile={true} />
              </div>
            ) : (
              this.renderSubCategoryLink(subCategory)
            )}
          </li>
        ))}
        <div onClick={this.handleOverlayClick}>
          <li className="nav-bar-overlay" />
        </div>
      </ul>
    );
  }
}

MobileNavBarSubCategory.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    sub_categories: PropTypes.arrayOf(
      PropTypes.shape({
        api_location: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    url: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  selectedCategory: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    sub_categories: PropTypes.arrayOf(
      PropTypes.shape({
        api_location: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    url: PropTypes.string,
  }).isRequired,
  selectedSubCategory: PropTypes.shape({
    api_location: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  subCategories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
};

MobileNavBarSubCategory.defaultProps = { subCategories: undefined };

export function mapStateToProps(state) {
  return {
    electricalGraphDateRange: state.utilityReducer.electricalGraphDateRange,
    gasGraphDateRange: state.utilityReducer.gasGraphDateRange,
    diagnosticsGraphDateRange: state.diagnosticsReducer.graphDateRange,
    thermostatGraphDateRange: state.suiteReducer.graphDateRange,
  };
}

const ConnectedMobileNavBarSubCategory = connect(mapStateToProps)(MobileNavBarSubCategory);
export { ConnectedMobileNavBarSubCategory };
